/** Following a wonderland never grants creation or commercial permissions. */
export const followCopy = {
  '公开': ['Public', '公開'],
  '私密': ['Private', '非公開'],
  '链接可见': ['Anyone with the link', 'リンクを知っている人'],
  '可见性待确认': ['Visibility unconfirmed', '公開範囲未確認'],
  '未命名系列': ['Untitled series', '無題のシリーズ'],
  '打开系列 {name}': ['Open series {name}', 'シリーズ {name} を開く'],
  '已关注': ['Following', 'フォロー中'],
  '已关注的': ['Following', 'フォロー中のシリーズ'],
  '关注系列': ['Follow series', 'シリーズをフォロー'],
  '还没有关注系列。': ['You are not following any series yet.', 'フォロー中のシリーズはまだありません。'],
  '登录后，回到你创建和关注的系列。': ['Sign in to return to series you create and follow.', 'ログインして、作成したシリーズやフォロー中のシリーズに戻れます。'],
  '我创建和关注的系列': ['Series I create and follow', '作成したシリーズとフォロー中のシリーズ'],
  '点击取消关注系列': ['Unfollow this series', 'このシリーズのフォローを解除'],
  '关注系列：{name}': ['Follow series: {name}', 'シリーズをフォロー：{name}'],
  '取消关注系列：{name}': ['Unfollow series: {name}', 'シリーズのフォローを解除：{name}'],
  '人已关注': ['followers', '人がフォロー中'],
  '已关注系列': ['Series followed', 'シリーズをフォローしました'],
  '已取消关注系列': ['Series unfollowed', 'シリーズのフォローを解除しました'],
  '未能更新关注状态，请重试。': ['Could not update following. Try again.', 'フォロー状態を更新できませんでした。再試行してください。'],
  '关注作者、关注系列或喜欢角色后，在这里看最新动态。': ['Follow creators and series or like characters to see their latest updates here.', '作者やシリーズをフォローしたり、キャラクターをお気に入りにすると、ここに最新情報が表示されます。'],
};
